// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__pZsf6","text":"SelectPayment_text__27w2i","title":"SelectPayment_title__cenCw","btn":"SelectPayment_btn__2qt6c"};